/* This example requires Tailwind CSS v2.0+ */
import { InboxIcon, SparklesIcon } from '@heroicons/react/outline'
import Image from 'next/image'

export default function Example() {
  return (
    <div className="relative bg-white py-32 overflow-hidden">
      <div className="relative">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div className="mt-6">
                <h2 className="text-3xl font-medium tracking-tight text-gray-900">Foundation. Blueprint.<br />Build.</h2>
                <p className="mt-4 text-lg text-gray-500">
                  Pinto’s 3-Step Process is a proven method to create Financial Success in small business.
                  <br />
                  <br />
                  Overnight success is usually a myth. We help you produce long-term financial stability and confidence in your business.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-12 sm:mt-16 lg:mt-0 p-4">
            <div className="lg:pl-4 lg:-mr-18 lg:px-0 lg:m-0 lg:relative lg:h-full overflow-hidden">
              <Image
                width={500}
                height={500}
                className="w-full lg:absolute lg:left-0 lg:w-auto"
                src="/HeroImg-V3-1.png"
                alt="Inbox user interface"
                unoptimized
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-24">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
            <div>
              <div className="mt-6">
                <h2 className="text-3xl font-medium tracking-tight text-gray-900">Financial Literacy</h2>
                <p className="mt-4 text-lg text-gray-500">
                  At Pinto, we are passionate about your financial success. Not just in your business success but in your Financial Literacy too.
                  <br />
                  <br />
                  Financial Literacy is an important step to overall success and we want to be sure you are continually  learning as we work together.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1">
            <div className="lg:-ml-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <Image
                width={500}
                height={500}
                className="w-full lg:absolute lg:right-0 lg:h-full lg:w-auto mx-auto lg:left-1/4"
                src="/Home-SecondSection 1.png"
                alt="Customer profile user interface"
                unoptimized
              />
            </div>
          </div>
        </div>
      </div>
      <div className="relative mt-24">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div className="mt-6">
                <h2 className="text-3xl font-medium tracking-tight text-gray-900">Your Small Business CFO</h2>
                <p className="mt-4 text-lg text-gray-500">
                  Pinto is an outsourced CFO with specific services tailored to small business. We provide what you need to be successful and not all the extras.
                  <br />
                  <br />
                  This helps us be price competitive and affordable for businesses like yours.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-12 sm:mt-16 lg:mt-0">
            <div className="lg:p-4 lg:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <Image
                width={500}
                height={500}
                className="w-full lg:absolute lg:left-0 lg:h-full lg:w-auto mx-auto lg:left-1/4"
                src="/Home-ThirdSection 1.png"
                alt="Your small business CFO"
                unoptimized
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

